export const MaintainHeightHook: {
  el?: HTMLElement
  prevHeight?: string | null
  beforeUpdate: () => void
  updated: () => void
} = {
  beforeUpdate() {
    if (!this.el) {
      return
    }

    this.prevHeight = this.el.style.height
  },

  updated() {
    if (!this.el) {
      return
    }

    this.el.style.height = this.prevHeight || 'auto'
  },
}
